module.exports = __webpack_public_path__ + "img/trailerFrontRightOutline.bd9b0d65.svg";